import { Box, Typography, Button, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LogoutButton from "../components/General/LogoutButton/LogoutButton";

const UnauthorizedPage = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        backgroundColor: "#f5f5f5",
        padding: 3,
      }}
    >
      <Typography
        variant="h1"
        component="h1"
        sx={{ color: "#ff1744", fontWeight: "bold", marginBottom: 2 }}
      >
        Unauthorized
      </Typography>
      <Typography
        variant="body1"
        component="p"
        sx={{ color: "#333", marginBottom: 4 }}
      >
        You are not authorized to view this page.
      </Typography>
      <Stack
        flexWrap={{ xs: "wrap", lg: "nowrap" }}
        useFlexGap
        direction="row"
        spacing={2}
      >
        <Button
          variant="contained"
          color="primary"
          onClick={handleGoBack}
          sx={{
            textTransform: "none",
            padding: "8px 16px",
            fontSize: "16px",
            borderRadius: "8px",
          }}
        >
          Go Back
        </Button>
        <LogoutButton />
      </Stack>
    </Box>
  );
};

export default UnauthorizedPage;
